import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export function getSamlSettings(tenantId: number) {
    return axios.get(`${API_URL}/v1/auth0/saml-settings`, {
        params: {
            tenantId: tenantId,
        },
    });
}
export function getConnectionList(tenantId: number) {
    return axios.get(`${API_URL}/v1/auth0/connection-list`, {
        params: {
            tenantId: tenantId,
        },
    });
}

export function getConnectionListNoTenant() {
    return axios.get(`${API_URL}/v1/auth0/connection-list`);
}


export function getConnectionDetails(connectionId: any) {
    return axios.get(`${API_URL}/v1/auth0/connection-details/${connectionId}`);
}

// Nueva función para crear una conexión SAML
export function createSamlConnection(formData: any, tenantId: number) {
    return axios.post(`${API_URL}/v1/auth0/create-saml-connection`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        params: {
            tenantId: tenantId,
        },
    });
}

// Nueva función para eliminar una conexión
export function deleteConnection(connectionId: any) {
    return axios.delete(`${API_URL}/v1/auth0/delete-connection/${connectionId}`);
}

// Nueva función para crear una conexión SCIM
export function createScimConnection(connectionId: any) {
    return axios.post(`${API_URL}/v1/auth0/create-scim/${connectionId}`);
}

// Nueva función para actualizar una conexión existente
export function updateConnection(connectionId: any, formData: any) {
    return axios.put(`${API_URL}/v1/auth0/update-connection/${connectionId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

// Nueva función para refrescar el token
export function refreshToken(connectionId: any) {
    return axios.put(`${API_URL}/v1/auth0/refresh-token/${connectionId}`);
}
